import {
  type HanMilesRedemption,
  redeemHanMilesOn,
} from "@-/dev.improve.haniverse.lib.han-currency";
import type { TravelOption } from "#resolve-travel-options";

/** The fare of a journey's flight legs: the only part HanMiles can discount. */
export function flightFareCny(option: TravelOption): number {
  let fareCny = 0;
  for (const leg of option.legs) {
    if (leg.mode === "flight") {
      fareCny += leg.fareCny;
    }
  }
  return fareCny;
}

/**
 * The most `hanMiles` can take off a journey: up to half its flight legs' fare, so a ground-only
 * journey gets nothing.
 */
export function travelOptionHanMilesRedemption(
  option: TravelOption,
  hanMiles: number,
): HanMilesRedemption {
  return redeemHanMilesOn({ flightFareCny: flightFareCny(option), hanMiles });
}
